import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { fireToastSuccess } from '../../actions/toasts/fireToast'
import i18n from '../../i18n'
import { RentLicensesActions } from '../../reducers/rentLicenses/actionNames'
import { getCalendarId } from '../../reducers/bookingCalendar/selectors/calendar'
import updateRentLicense from '../../models/RentLicenses/updateRentLicense'
import { Mixpanel } from '../../utils/Mixpanel'
import { getUserId } from '../../reducers/userAccount/selectors/userAccount'
import { getSortedRoomsByPosition } from '../../reducers/bookingCalendar/selectors/rooms'

function* saveRentLicenses(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.SaveRentLicenses)
    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, updateRentLicense),
      ),
    ])

    const calendarId = yield Effects.select(getCalendarId)
    const userId = yield Effects.select(getUserId)

    const licensesNew = action.payload.licenses.filter(l => !l.id)
    const rooms = yield Effects.select(getSortedRoomsByPosition)

    const allRoomsSelected = action.payload.licenses
      ? action.payload.licenses.reduce((acc, item) => {
          if (item.rooms) {
            return acc.concat(item.rooms)
          }
          return acc
        }, [])
      : []

    const roomsFiltered = rooms.filter(r => !allRoomsSelected.includes(r.id))

    licensesNew.forEach(l => {
      Mixpanel.track('Licence Number New Licence Created', {
        'Licence Number': l.license,
      })
      Mixpanel.people.increment(userId, 'Licence Created', 1)
    })

    yield Effects.call(service, {
      id_calendar: String(calendarId),
      licenses: action.payload.licenses.map(l => {
        if (l.selection_type === '2') {
          return { ...l, rooms: roomsFiltered.map(r => r.id) }
        }

        if (l.selection_type === '0') {
          return { ...l, rooms: rooms.map(r => r.id) }
        }

        return l
      }),
    })

    // yield Effects.put({
    //   services,
    //   type: PaymentDictionaryActions.AcceptedPrepayment,
    // })
    yield put(fireToastSuccess(i18n.t('user_settings_updated')))
    yield put({ type: RentLicensesActions.LoadRentLicenses })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeEvery(
    RentLicensesActions.SaveRentLicenses,
    saveRentLicenses,
  )
}
